import { IconButton } from "@mui/material";
import { Stack } from "@mui/system";
import CheckIcon from "@mui/icons-material/Check";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import { useSelector } from "react-redux";
import { topKeywordsForMobile } from "../../../../../AdditionalQueries/AdditionalQueriesAccordion/AdditionalQueriesConstants";
import saveAs from "file-saver";

type Props = {
  value: string;
  onChange: (value: string) => void;
  loading: boolean;
};

const options = ["YTD", "Yesterday", "Last 7 days", "Last month", "MTD"];

const KeywordsDateFilter = ({ value, onChange, loading }: Props) => {
  const { keywordsQueryData } = useSelector(
    (state: any) => state.businessLeaderDashBoard,
  );

  const getMetricValueForCSV = (key: any, value: any) => {
    if (value === 0) {
      return value;
    } else if (key === "imp_share" || key === "CVR") {
      value = value * 100;
      value = Math.round(value);
      return value + "%";
    } else if (
      key !== "FTD" &&
      key !== "campaign_name" &&
      key !== "adgroup_name" &&
      key !== "kw_name" &&
      key !== "matchtype" &&
      key !== "tier" &&
      key !== "traffic_source"
    ) {
      value = Math.round(value);
      return value + "$";
    } else {
      return value;
    }
  };

  const handleExportCSV = () => {
    const csvRows = [];
    const headers = topKeywordsForMobile?.map((pair: any) => pair.key) as any;
    csvRows.push(headers.join(","));
    // eslint-disable-next-line
    keywordsQueryData?.query_output?.map((row: any) => {
      let rowData = [] as any;
      // eslint-disable-next-line
      headers.map((key: any) => {
        const result = getMetricValueForCSV(key, row[key]);
        if (result !== "null") {
          rowData.push(result);
        }
      });
      if (rowData?.length > 0) {
        csvRows.push(rowData.join(","));
      }
    });
    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "TopKeywords.csv");
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          mt: spacing.Spacing.xs.$value,
        }}
      >
        <Autocomplete
          options={options}
          disabled={loading}
          data-tracker="663"
          value={value}
          onChange={(_, newValue) => {
            if (!newValue) return;
            onChange(newValue);
          }}
          sx={{
            width: "80%",
            "& .MuiInputBase-input": {
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
              fontWeight: typography.Font_weight.Semibold.$value,
              py: "0px !important",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: spacing.Radius.md.$value,
              "&.Mui-focused fieldset": {
                borderColor: colors.GrayLightMode[300].$value,
                borderWidth: "1px",
              },
            },
          }}
          size="small"
          renderOption={(props, option, { selected }) => (
            <li
              {...props}
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: spacing.Spacing["5xl"].$value,
                position: "relative",
                backgroundColor: selected ? colors.Brand[50].$value : "",
              }}
            >
              {selected && (
                <CheckIcon
                  fontSize="small"
                  sx={{
                    position: "absolute",
                    left: spacing.Spacing.lg.$value,
                  }}
                />
              )}
              <span style={{}}>{option}</span>
            </li>
          )}
          renderInput={(params) => <TextField color="secondary" {...params} />}
        />

        <IconButton
          color="secondary"
          size="large"
          onClick={handleExportCSV}
          data-tracker="664"
          disabled={loading}
        >
          <FileDownloadIcon sx={{ color: colors.GrayLightMode[700].$value }} />
        </IconButton>
      </Stack>
    </>
  );
};

export default KeywordsDateFilter;
